import { convertTimestampToLocalString } from 'utils/times'
import { sortBy } from 'lodash'
import moment from 'moment'
import { TalkStatus } from 'constants/index'
import { colors } from 'utils/colors'
import { extendMoment } from 'moment-range'

export const getUpdatedTalksAlongEventAndSession = (talks, events, sessions, timezone, format) => {
  const eventMap = new Map(events?.map((event) => [event.id, event]))
  const sessionMap = new Map(sessions?.map((session) => [session.id, session]))

  const updatedTalks = talks?.map((talk) => {
    const event = eventMap.get(talk?.eventId)
    const session = sessionMap.get(talk?.sessionId)

    return {
      ...talk,
      startDate: talk?.startDate
        ? convertTimestampToLocalString(talk?.startDate, timezone, format)
        : '',
      endDate: talk?.endDate ? convertTimestampToLocalString(talk?.endDate, timezone, format) : '',
      eventTitle: event?.title ?? 'N/A',
      eventStartTime: event?.startDate
        ? convertTimestampToLocalString(event?.startDate, timezone, format)
        : '',
      eventEndTime: event?.endDate
        ? convertTimestampToLocalString(event?.endDate, timezone, format)
        : '',
      sessionTitle: session?.title ?? 'N/A',
      sessionStartTime: session?.startDate
        ? convertTimestampToLocalString(session?.startDate, timezone, format)
        : '',
      sessionEndTime: session?.endDate
        ? convertTimestampToLocalString(session?.endDate, timezone, format)
        : ''
    }
  })

  return sortBy(updatedTalks, (obj) => moment(obj?.startDate))
}

export const getTalkStatusText = (status) => {
  if (status === TalkStatus.ASSOCIATED) {
    return { status, bgColor: '#29b6f6', color: colors.white }
  } else return { status, bgColor: '#ffc107', color: colors.black }
}

export const isDateTimeInRange = (startDateTime, endDateTime, venueId, talks) => {
  // @ts-ignore
  const Moment_Range = extendMoment(moment)
  const startDateTimeInUTC = moment(startDateTime)
  const endDateTimeInUTC = moment(endDateTime)
  const range = Moment_Range.range(startDateTimeInUTC, endDateTimeInUTC)
  return talks.some((talk) => {
    const startDateUTC = moment(talk?.startDate)
    const endDateUTC = moment(talk?.endDate)
    const range1 = Moment_Range.range(startDateUTC, endDateUTC)
    return (range.overlaps(range1) || range1.overlaps(range)) && venueId === talk?.venueId
  })
}

// range1.contains(startDateTimeInUTC) ||
// range1.contains(endDateTimeInUTC) ||
